/* eslint-disable @typescript-eslint/no-explicit-any */
import type { RemixerState } from './remixer/types';
import type { DistributionState } from './distribution/types';
import type { BaseActionStore } from './base';
import type { UserStore } from './user';
import type { AuthStore } from './auth';
import type { SongsStore } from './songs';
import type { TagStore } from './tags';
import type { AIStore } from './ai';
import type { DiscoveryStore } from './discovery';
import type { NewSongsState } from './newSongs/types';

export type Action<T> = {
  type: string;
  payload: T;
};

interface ActionCreator<P> {
  type: string;
  (payload: P): Action<P>;
}

export function actionCreator<P>(type: string): ActionCreator<P> {
  return Object.assign((payload: P) => ({ type, payload }), { type });
}

export function isActionOfType<P>(
  action: Action<any>,
  creator: ActionCreator<P>
): action is Action<P> {
  return action.type === creator.type;
}

/**
 * @deprecated: use RootState instead
 */
export type StoreRootState = {
  base: BaseActionStore;
  user: UserStore;
  auth: AuthStore;
  songs: SongsStore;
  tags: TagStore;
  ai: AIStore;
  discovery: DiscoveryStore;
  remixer: RemixerState;
  distribution: DistributionState;
  newSongs: NewSongsState;
};

export type {
  BaseActionStore,
  UserStore,
  AuthStore,
  SongsStore,
  TagStore,
  AIStore,
  DiscoveryStore,
};
